import { tokenService } from '../services/token';

export function useHasCompleteAuthToken() {
  const hasAccessToken = !!tokenService.getAccessToken();
  const hasRefreshToken = !!tokenService.getRefreshToken();
  const hasCSRFToken = !!tokenService.getCSRFToken();
  return hasAccessToken && hasRefreshToken && hasCSRFToken;
}
